import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { DeterminantRegistrationRelations } from "../../../models/determinant_registration_relations";
import { DeterminantRegistrationsControllerService } from "../../../services/crossed-tables/determinant-registrations-controller.service";
import { Store } from "../../../services/store.service";
import { ModalService } from "../../utils/base_modal.component";
import { BaseError } from "../base-error";

@Component({
  selector: "app-determinant-registrations",
  templateUrl: "./determinant-registrations.component.html",
  providers: [DeterminantRegistrationsControllerService, ModalService],
  styles: [".cursor-hand {cursor: pointer;}"],
})
export class DeterminantRegistrationsComponent extends BaseError implements OnInit {
  public determinantRegistrationRelations: DeterminantRegistrationRelations[][] = [];
  public selectedDeterminantRegistrationRelations: DeterminantRegistrationRelations = new DeterminantRegistrationRelations();
  public serviceId: string;
  public showModal = false;
  public tableSwitched: boolean = false;

  constructor(private determinantRegistrationsControllerService: DeterminantRegistrationsControllerService,
              public store: Store,
              private route: ActivatedRoute,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.getDeterminantRegistrationRelations();
  }

  public getDeterminantRegistrationRelations() {
    this.determinantRegistrationsControllerService.getDeterminantRegistrationsRelationsList(this.serviceId).subscribe(
      (data) => {
        this.determinantRegistrationRelations = data;
        if (this.tableSwitched) {
          this.tableSwitched = false;
          this.switchHeadings();
        }
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public switchHeadings() {
    this.tableSwitched = !this.tableSwitched;
    const switchedEntries = [];
    if (this.determinantRegistrationRelations[0]) {
      for (let j = 0; j < this.determinantRegistrationRelations[0].length; j++) {
        const newRow = [];
        for (let i = 0; i < this.determinantRegistrationRelations.length; i++) {
          newRow.push(this.determinantRegistrationRelations[i][j]);
        }
        switchedEntries.push(newRow);
      }
    }
    this.determinantRegistrationRelations = switchedEntries;
  }

  public updateDeterminantRegistrationRelations(determinantRegistrationRelations: DeterminantRegistrationRelations) {
    this.determinantRegistrationsControllerService.saveDeterminantRegistrationsRelation(determinantRegistrationRelations).subscribe(
      (data) => {
        this.getDeterminantRegistrationRelations();
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public editDeterminant(determinantRegistrationRelations: DeterminantRegistrationRelations) {
    if (determinantRegistrationRelations) {
      this.showModal = true;
      this.selectedDeterminantRegistrationRelations = determinantRegistrationRelations;
    }

  }

  public onCancel() {
    this.showModal = false;
  }

  public onOk() {
    this.updateDeterminatType(this.selectedDeterminantRegistrationRelations);
    this.showModal = false;
  }

  public updateDeterminatType(determinantRegistrationRelations: DeterminantRegistrationRelations) {
    this.updateDeterminantRegistrationRelations(determinantRegistrationRelations);
  }

  public closeEdit() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
  }

}
